import React, { useEffect, useState } from "react";
import css from "./Homepage.module.css";
import { speciesList } from "../Panelview/List";
import { useSearch } from "../../hooks/search";
import ListDatabaseHP from "./ListDatabaseHP";
import Spinner from "../Spinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  minimumChatacters,
  warningSearchMessage,
} from "../warningSearchMessage";

const SearchHomepage = () => {
  const [term, setTerm] = useState(""),
    [showSpinnerFetch, setShowSpinnerFetch] = useState(false),
    [species, setSpecies] = useState("hsapiens"),
    [showWarning, setShowWarning] = useState(false),
    [debouncedTerm, setDebouncedTerm] = useState(term);

  const { dataRetrieved, isLoadingSearch } = useSearch(term, species);

  const setTermWithWarning = () => {
    if (debouncedTerm.length <= minimumChatacters && debouncedTerm !== "") {
      setShowWarning(true);
    } else {
      setShowWarning(false);
      setTerm(debouncedTerm);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => setTermWithWarning(), 1000);
    return () => clearTimeout(timer);
  }, [debouncedTerm]);

  const ListSection = () =>
    isLoadingSearch ? (
      <Spinner size={"4x"} />
    ) : (
      <ListDatabaseHP
        dbList={dataRetrieved.items[species]}
        statusSearch={dataRetrieved.status}
        setShowSpinnerFetch={setShowSpinnerFetch}
      />
    );

  return (
    <div className={css.searchHomepage}>
      <div className={css.searchDivHP}>
        <div className={css.searchFormHP}>
          <input
            value={debouncedTerm}
            className={css.inputSearchHP}
            type="text"
            placeholder="Search for pathways title..."
            onChange={(e) => setDebouncedTerm(e.target.value)}
          />
        </div>
        <div
          className={css.searchWarningHP}
          style={{
            visibility: showWarning ? "visible" : "hidden",
          }}
        >
          {warningSearchMessage}
        </div>
      </div>
      <div className={css.contentSpeciesDBList}>
        <div className={css.dropdownSpeciesHP}>
          Species:{" "}
          <select
            value={species}
            onChange={(event) => setSpecies(event.currentTarget.value)}
          >
            {speciesList.map((spc) => {
              return (
                <option value={spc} key={spc}>
                  {`${spc[0].toUpperCase()}. ${spc.slice(1)}`}
                </option>
              );
            })}
          </select>
        </div>
        <ListSection />
      </div>
      {showSpinnerFetch ? (
        <div
          style={{
            height: "100%",
            width: "100%",
            zIndex: "10",
            placeSelf: "center",
            gridRow: "1/3",
            gridColumn: "1/2",
            backgroundColor: "rgba(255,255,255,0.5)",
          }}
        >
          <Spinner size={"4x"} />
        </div>
      ) : null}
    </div>
  );
};

export default SearchHomepage;
